export default () => {
  // elements
  const els = {
    searchBtn: document.querySelector('[data-page-header-search-btn]'),
    searchInput: document.querySelector('[data-page-header-search-input]'),
    searchForm: document.querySelector('[data-page-header-search-form]'),
    searchToggle: document.querySelector('.search-mobile-toggle'),
    searchMobile: document.querySelector('.search-mobile'),
    searchMobileClose: document.querySelector('.search-mobile__close')
  };

  // classes
  const classes = {
    searchBtnActive: 'page-header__search-btn--active',
    searchInputActive: 'page-header__search-input--active',
  };

  // functions
  const showSearchInput = () => {
    els.searchBtn.classList.add(classes.searchBtnActive);
    els.searchInput.classList.add(classes.searchInputActive);
    els.searchInput.setAttribute('placeholder', 'Search');
  };

  const hideSearchInput = () => {
    els.searchBtn.classList.remove(classes.searchBtnActive);
    els.searchInput.classList.remove(classes.searchInputActive);
  };

  const submitSearchInput = () => {
    els.searchForm.submit();
  };

  const handleSearchMobile = (event) => {
    event.preventDefault();
    els.searchMobile.classList.add('active');
  };

  const handleSearchMobileClose = (event) => {
    event.preventDefault();
    els.searchMobile.classList.remove('active');
  };

  // handlers
  const handleSearchBtnClick = (e) => {
    e.preventDefault();
    els.searchInput.focus();
  };

  // apply event listeners
  els.searchBtn.addEventListener('click', handleSearchBtnClick);
  // els.searchToggle.addEventListener('click', handleSearchMobile);
  // els.searchMobileClose.addEventListener('click', handleSearchMobileClose);
  els.searchInput.addEventListener('focus', showSearchInput);
  els.searchInput.addEventListener('blur', hideSearchInput);
  els.searchInput.addEventListener('keypress', (e) => {
    // on press enter
    if (e.which === 13 || e.keyCode === 13) {
      submitSearchInput();
    }
    return true;
  });

};
